import React from 'react';
import PropTypes from 'prop-types';
import { Button, Helper } from 'Components';
import i18n from 'i18next';
import './SummaryHeader.css';

const SummaryHeader = ({ onClick, title, tutorialText, hideButton }) => (
  <Helper text={tutorialText}>
    <Button onClick={onClick} className="summary__header">
      <span className="summary__header__title">{title}</span>
      {!hideButton && (
        <div className="summary__header__icon">
          <i className="material-icons ">edit</i>
          <span>{i18n.t('common:edit')}</span>
        </div>
      )}
    </Button>
  </Helper>
);

SummaryHeader.propTypes = {
  onClick: PropTypes.func,
  title: PropTypes.string,
  tutorialText: PropTypes.string,
  hideButton: PropTypes.bool,
};

export default SummaryHeader;



// WEBPACK FOOTER //
// ./src/components/SummaryHeader/SummaryHeader.jsx